import React from "react";

const Signature = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M11.37 32.582a1.35 1.35 0 0 1-.402-.96c0-.359.144-.703.402-.959.548-.614 1.361-1.508 2.927-1.508s2.407.924 2.955 1.535c.476.534.592.614.885.614.293 0 .408-.08.885-.614.545-.61 1.361-1.535 2.955-1.535 1.593 0 2.41.924 2.954 1.535.477.534.592.614.885.614.293 0 .409-.08.885-.614.324-.363.82-.528 1.302-.435.482.094.876.432 1.035.888.158.456.056.96-.267 1.322-.545.61-1.362 1.535-2.955 1.535s-2.41-.924-2.955-1.535c-.476-.534-.592-.614-.885-.614-.293 0-.408.08-.885.614-.544.61-1.361 1.535-2.95 1.535-1.59 0-2.418-.924-2.972-1.535-.477-.534-.593-.614-.886-.614-.292 0-.408.08-.884.614l-.058.06-.041.043c-.254.254-.6.398-.963.4a1.375 1.375 0 0 1-.967-.386Zm3.84-7.314-7.125 3.727a1.443 1.443 0 0 1-.965.134 1.42 1.42 0 0 1-.824-.509A1.369 1.369 0 0 1 6 27.71l.34-7.908c.014-.236.09-.466.219-.667l10.607-16.35c.2-.311.518-.532.885-.614a7.212 7.212 0 0 1 5.34.897A6.957 6.957 0 0 1 26.528 7.4c.083.36.017.736-.184 1.048l-10.607 16.35c-.132.198-.314.36-.528.47Zm-1.679-2.279a4.187 4.187 0 0 0-1.72-2.073 4.319 4.319 0 0 0-2.65-.623l-.12 3.09a2.853 2.853 0 0 1 1.702 1.064l2.788-1.458Z"
            fill={fill}
        />
    </svg>
);

export default Signature;